import CONSTANTS from '../CONSTANTS';

const initialState = {
  kits: {},
  patientKits: {},
  types: {},
  kitEdit: {},
  kitsCount: {},
  kitsCountByState: {},
  stateMachine: {},
  stateGroups: { groups: [], stateToGroup: {} },
  states: {},
  activeTab: "k_st_3",
  kitListLoading: false
};

const kitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.KITS_SET_LIST:
      return { ...state, kits: action.kits };
    case CONSTANTS.KITS_SET_EDIT:
      return { ...state, kitEdit: action.kit };
    case CONSTANTS.KITS_PATIENTS_SET: 
      return { ...state, patientKits: action.kits };

    case CONSTANTS.KITS_SET_STATE_MACHINE:
      return { ...state, stateMachine: action.machine };

    case CONSTANTS.KITS_SET_STATE_GROUPS:
      return { ...state, stateGroups: action.stateGroups };
    
    case CONSTANTS.KITS_SET_COUNT_BY_STATE: 
      return { ...state, kitsCountByState: action.count };
    
    case CONSTANTS.KITS_SET_STATE_LIST: 
      return { ...state, states: action.states };

    case CONSTANTS.KITS_SET_LOADING_LIST: 
      return { ...state, kitListLoading: action.value };

    case CONSTANTS.KITS_UPDATE_IN_LIST: {
      if (state.kits.data) {
        //get list of kits IDs only
        let kitsIDList = state.kits.data.map(a => a._id);
        let newKitList = [...state.kits.data];
        const kitIndex = kitsIDList.indexOf(action.kitId);

        if (kitIndex > -1) {
          newKitList[kitIndex] = action.data;
        }

        return {...state, kits: {...state.kits, data: [...newKitList]}};
      }

      return {...state};
    }

    case CONSTANTS.KITS_SET_COUNT_BY_TYPE:
      return { ...state, kitsCount: action.count };

    case CONSTANTS.KITS_SET_TYPES: 
      return { ...state, types: action.types };

    case CONSTANTS.KITS_SET_TAB:
      return { ...state, activeTab: action.tab };

    default:
      return state;
  }
};

export default kitsReducer;